import { saveNoCacheValue } from './no-cache-links';

declare const wp: any;
declare const crscInstructorData: {
    nonce: string;
};

/**
 * Initializes the instructor product confirmation process to verify an instructor can purchase an instructor only product.
 *
 * Sets up event listeners and performs an API request to verify
 * the instructor code entered by the user.
 */
export const initInstructorProduct = () => {
    const form = document.getElementById('instructor-confirmation-form') as HTMLFormElement | null;
    const confirmBtn = document.getElementById('confirm_instructor_code') as HTMLButtonElement | null;
    const inputField = document.getElementById('instructor_code') as HTMLInputElement | null;
    const messageDiv = document.getElementById('instructor_confirmation_message');

    if (form && confirmBtn && inputField && messageDiv) {
        form.addEventListener('submit', (event) => {
            event.preventDefault();

            const code = inputField.value.trim();
            const nonceInput = form.querySelector('input[name="instructor_nonce"]') as HTMLInputElement | null;
            const nonce = nonceInput ? nonceInput.value : '';

            if (!code) {
                messageDiv.textContent = 'Please enter an instructor number.';
                messageDiv.style.color = 'red';
                return;
            }

            confirmBtn.disabled = true;
            messageDiv.textContent = 'Verifying instructor number...';
            messageDiv.style.color = 'inherit';

            wp.apiFetch({
                path: 'crsc-dbs/v1/confirm-instructor-code',
                method: 'POST',
                data: {
                    code: code,
                    instructor_nonce: nonce
                },
                headers: {
                    'X-WP-Nonce': crscInstructorData.nonce
                },
                credentials: 'include'
            })
            .then((data: { success: boolean }) => {
                if (data.success) {
                    messageDiv.textContent = 'Instructor number confirmed! Reloading page...';
                    messageDiv.style.color = 'green';
                    // Reload page to allow purchasing the instructor only product and bust the cache
                    let currentUrl = new URL(window.location.href);
                    let randomValue = Date.now() + btoa( code );
                    saveNoCacheValue( randomValue );
                    currentUrl.searchParams.set('crsc_no_cache', randomValue);
                    window.location.href = currentUrl.toString();
                }

                messageDiv.textContent = 'Invalid instructor number. Please try again.';
                messageDiv.style.color = 'red';
                confirmBtn.disabled = false;
            })
            .catch((error: any) => {
                console.error('Error:', error);
                messageDiv.textContent = 'An error occurred. Please try again later.';
                messageDiv.style.color = 'red';
                confirmBtn.disabled = false;
            });
        });
    }
};
